import { blogHeaderRedux } from "@/app/store/blog-header/reducers";
import { blogListRedux } from "@/app/store/blog-list/reducers";
import clearAllCookies from "@/utils/clearAllCookies";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const AppInitialize = ({ children }) => {
  const dispatch = useDispatch();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    clearAllCookies();
    dispatch(blogListRedux.actions.getBlogListByCategoryRequest({ categorySlug: "" }));

    setTimeout(() => {
      dispatch(blogHeaderRedux.actions.openSubscribeModal());
    }, 5000);
  }, [dispatch]);

  if (!isClient) return null;

  return <>{children}</>;
};

export default AppInitialize;
